import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSelectedGbpFilter, setSelectionFlag, setApplyFilter as setApplyForecastFilter } from '../../services/redux/reducer/filter.reducer';
import { setApplyFilter, setClearState } from '../../services/redux/reducer/demandfilter.reducer';
import { IPredectivePayload } from '../../services/interface/IHome';

const useNavigateHandler = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const initialState:IPredectivePayload = {
        plant: [],
        l2: [],
        l3: [],
        materialDescription: [],
        material: [],
        mrpType: [],
        futureSegmentation: [],
        vendorName: [],
        clustername: [],
        alerts: [],
        reviewedFlag: [],
        poAlert: [],
        adjustedLogic:[]
    }
    const navigateTo = (value: string | null) => {
        if (value) {
            navigate(value);
            dispatch(setSelectionFlag(false));
            dispatch(setSelectedGbpFilter(initialState));
            dispatch(setApplyFilter({"status" : false, "rowNo" : -1}));
            dispatch(setApplyForecastFilter({"status" : false, "rowNo" : -1}));
            dispatch(setClearState());
        }
    };

    return { navigateTo };
};

export default useNavigateHandler;
